import { useContext } from "react";

import { FlowContext } from "../../context/FlowContext";

export const useFlowContext = () => useContext(FlowContext);
